module.exports = __webpack_public_path__ + "static/media/surface-1.aaf2ebad.png";